<!--
  Lovi
  登录注册 2020-06-01
-->
<template>
  <div class="w100 logReg">
    <div class="top">
      <router-link class="to-home" to="/index">
        <van-icon name="cross" />
      </router-link>
      <img class="logo" src="@/assets/images/public/logo@2x.png" />
      <h1>{{ $t("logReg.welcome") }}</h1>
      <div class="btn-wrap">
        <van-button block type="primary" to="/log">
          {{ $t("common.login") }}
        </van-button>
        <van-button block type="default" to="/reg">
          {{ $t("common.register") }}
        </van-button>
      </div>
      <p class="text-right">
        <span @click="_linkFun('/retrievePsd')">
          {{ $t("common.retrievePassword") }}
        </span>
      </p>
    </div>

    <div class="bottom">
      <!--<div class="thirdParty">
        <ul>
          <li>
            <fb-signin-button
              :params="fbSignInParams"
              @success="onSignInSuccess"
              @error="onSignInError"
            >
            &lt;!&ndash;  <img src="@/assets/images/logReg/icon_thirdParty_fb@2x.png" />
              <p>{{ $t("logReg.facebookLogin") }}</p>&ndash;&gt;
              <p>Copyright All All Rights Reserved  2022 eepay</p>
            </fb-signin-button>
          </li>
        </ul>
      </div>-->

      <div class="thirdParty">
     <ul>
       <li>
         Copyright All All Rights Reserved  2022 eepay
       </li>
     </ul>
   </div>


      <div class="agreement">
        <span @click="clickAgreement">{{ $t("logReg.agreementTips") }}</span>
      </div>
    </div>
    <transition name="slide">
      <agreement v-if="agreementFlag" :agreementFlag.sync="agreementFlag" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import agreement from "./agreement";
export default {
  name: "logReg",
  meta: {
    power: false,
    service: false
  },
  components: {
    agreement
  },
  data() {
    return {
      //Facebook
      fbSignInParams: {
        scope: "public_profile,email",
        return_scopes: true
      },
      agreementFlag: false
    };
  },
  created() {
    this.introduceJsFile();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    clickAgreement() {
      // 点击服务协议
      this.agreementFlag = !this.agreementFlag;
    },
    introduceJsFile() {
      // 创建JS引入文件
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      script.async = "async";
      script.defer = "defer";
      script.crossOrigin = "anonymous";
      script.src =
        "https://connect.facebook.net/" +
        (this.language == "en" ? "en_US" : "zh_CN") +
        "/sdk.js#xfbml=1&version=v6.0&appId=605680983386590&autoLogAppEvents=1";
      // en_US
      head.appendChild(script);
      console.log("introduceJsFile", head.appendChild(script));
    },
    onSignInSuccess(response) {
      //facebook的登录信息
      let vm = this;
      console.log("Success", response);
      /* eslint-disable */
      FB.api("/me", function(response) {
        console.log("/me", response);
        vm.loginByThird(2, response.id, response.name);
      });
    },
    onSignInError(error) {
      //facebook的登录报错信息
      console.log("Error", error);
    },
    loginByThird(type, id, name) {
      // 第三方登录
      let vm = this;
      let params = {};
      params.type = type;
      params.mark = id;
      params.nickname = name;
      vm.$post("/app/user/loginByThird", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("loginByThird", res);
        if (res.code == 0) {
          vm.$toast(res.msg);
          localStorage.setItem("token", res.data.token);
          vm.$store.dispatch('SET_TOKEN', res.data.token)
          vm.$store.dispatch("GET_USER_INFO");
          vm.$router.push({
            path: "/home"
          });
        } else if (res.code == 20013) {
          // 20013 第三方账号未注册
          vm.$router.push({
            path: "/reg",
            name: "reg",
            query: { flag: "third" },
            params: params
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.logReg {
  padding: 0 20px;
  min-height: 100vh;
  background-image: url("~@/assets/images/logReg/bg@2x.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-attachment: fixed;
  background-size: cover;
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  .to-home {
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 10px;
    /deep/.van-icon-cross {
      float: left;
      color: #fff;
      font-size: 24px;
    }
  }
  .logo {
    margin-top: 70px;
    height: 40px;
  }
  h1 {
    margin: 30px 0;
    font-size: 30px;
    font-weight: 500;
    line-height: 30px;
    color: #fff;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  }
  .btn-wrap {
    /deep/.van-button {
      margin-bottom: 15px;
      &.van-button--default {
        color: #fff;
        height: 45px;
        line-height: 43px;
        background: transparent;
        border: 1.1px solid #fff;
      }
    }
  }

  .text-right {
    color: #fff;
    line-height: 20px;
    text-align: right;
  }

  .bottom {
    line-height: 20px;
    color: #fff;
    .thirdParty {
      padding: 20px 60px;
      ul {
        display: flex;
        justify-content: center;
        li {
          margin: 0 15px;
          text-align: center;
          img {
            width: 55px;
            height: 55px;
          }
          p {
            margin-top: 5px;
          }
        }
      }
    }
    .agreement {
      line-height: 30px;
      text-align: center;
      font-size: 10px;
      // span {
      //   color: #5da8ff;
      // }
    }
  }
}
</style>
